/**
 * @file Divider 分割线
 * @description 水平或垂直分隔。
 *
 * @whenToUse 表单分组、菜单项分隔。
 * @whenNotToUse 大区块间距（用 margin/padding）。
 */

import { cn } from '@/lib/cn.ts'

export type DividerProps = {
  orientation?: 'horizontal' | 'vertical'
  className?: string
}

export function Divider({
  orientation = 'horizontal',
  className,
}: DividerProps) {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn(
        'bg-border',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px self-stretch',
        className,
      )}
    />
  )
}
